// extracted by mini-css-extract-plugin
export default {"buttons":"CreateCardButtons_buttons__aKq+X","buttons__settings":"CreateCardButtons_buttons__settings__08p+p"};